export default "__VITE_ASSET__CV_ind2Q__"